/**
 * Normally the variable and function should use the case of "dataUrl" instead
 * of "dataURL".
 *
 * However, since the readAsDataURL function which is defined by the W3C puts
 * the acronym URL in uppercase, this file follows this convention in order to
 * avoid confusion.
 */
function dataURLMustBeBase64(dataURL) {
    const search = ';base64,';
    const base64PrefixStart = dataURL.indexOf(search);

    if (base64PrefixStart < 0) {
        throw new Error(
            'Your browser is not supported: it generates data URLs without base64.'
        );
    }

    const base64Start = base64PrefixStart + search.length;

    if (base64Start >= dataURL.length) {
        throw new Error('The URL contains an empty base64 file.');
    }

    return dataURL;
}

class BlobRequestService {
    createFileReader() {
        return new FileReader();
    }
}

class BlobToBase64Service {
    constructor(theBlobRequestService) {
        this.theBlobRequestService = theBlobRequestService;
        this.reader = null;
        this.releaseAtQueueEnd = false;
        this.currentTask = null;
        this.queue = [];
    }

    initReader() {
        if (this.reader === null) {
            const newReader = this.theBlobRequestService.createFileReader();

            newReader.addEventListener('load', this.convertDataURL, false);
            newReader.addEventListener('error', this.rejectCurrentEvent, false);

            this.reader = newReader;
            this.releaseAtQueueEnd = false;
        }
    }

    releaseReader() {
        if (this.queue.length === 0 && this.currentTask === null) {
            const { reader: oldReader } = this;

            // releaseReader might be called while reader is already released.
            if (oldReader !== null) {
                oldReader.removeEventListener(
                    'load',
                    this.convertDataURL,
                    false,
                );

                oldReader.removeEventListener(
                    'error',
                    this.rejectCurrentEvent,
                    false,
                );

                this.reader = null;
            }

            this.releaseAtQueueEnd = false;
        } else {
            this.releaseAtQueueEnd = true;
        }
    }

    resolveCurrent(result) {
        const { resolve } = this.currentTask;

        resolve(result);
        this.runQueue();
    }

    rejectCurrent(theError) {
        const { reject } = this.currentTask;

        reject(theError);
        this.runQueue();
    }

    rejectCurrentEvent = () => {
        this.rejectCurrent(this.reader.error);
    };

    convertDataURL = () => {
        try {
            this.resolveCurrent(dataURLMustBeBase64(this.reader.result));
        } catch (theError) {
            this.rejectCurrent(theError);
        }
    };

    runQueue() {
        const { queue } = this;

        if (queue.length === 0) {
            this.currentTask = null;

            if (this.releaseAtQueueEnd) {
                this.releaseReader();
            }
        } else {
            this.currentTask = queue.shift();
            this.initReader();
            this.reader.readAsDataURL(this.currentTask.theBlob);
        }
    }

    encode(theBlob) {
        const startQueue = this.currentTask === null;

        return new Promise((resolve, reject) => {
            this.queue.push({
                resolve,
                reject,
                theBlob,
            });

            if (startQueue) {
                this.runQueue();
            }
        });
    }
}

const singleton = new BlobToBase64Service(
    new BlobRequestService(),
);

export default singleton;
